import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup, FormControlLabel, withStyles } from '@material-ui/core';
import { colors } from 'kangarootime-ui';

const styles = theme => ({
  radio: {
    '&$checked': {
      color: colors.brand_3
    }
  },
  checked: {}
});

const UserTypeSelection = ({
  selectedValue,
  onSelect,
  ...props
}) => {
  const { classes } = props;

  return (
    <RadioGroup
      row
      value={selectedValue}
      onChange={event => onSelect(event.target.value)}
    >
      <FormControlLabel
        label='Employees'
        value='employee'
        control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
      />
      <FormControlLabel
        label='Parents'
        value='parent'
        control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
      />
    </RadioGroup>
  );
};

UserTypeSelection.propTypes = {
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func
};

export default withStyles(styles)(UserTypeSelection);
